import { Roles } from "common/config/roles.config";
import { RootState } from "common/redux/core/root.reducer";
import { useSelector } from "react-redux";

const useAppPermission = () => {
  const userRoles = useSelector((state: RootState) => state.user.userRole);

  const hasAdminRole = userRoles.includes(Roles.ADMIN);

  return {
    hasAdminRole
  };
};

export default useAppPermission;
